module.exports = __webpack_public_path__ + "static/media/meditation4.194ea0f7.mp3";